import o from "@emotion/styled/base";
import { HEX_COLORS as b } from "@partoohub/branding";
const l = {
  danger: ({
    theme: g
  }) => `
      background-color: ${g.colors.danger.alpha};
      color: ${g.colors.danger.text};
    `,
  default: ({
    theme: g
  }) => `
      background-color: ${g.colors.default.alpha};
      color: ${g.colors.default.text};
    `,
  secondary: ({
    theme: g
  }) => `
      background-color: ${g.colors.secondary.alpha};
      color: ${g.colors.secondary.text};
    `,
  primary: ({
    theme: g
  }) => `
      background-color: ${g.colors.primary.alpha};
      color: ${g.colors.primary.text};
    `,
  success: ({
    theme: g
  }) => `
      background-color: ${g.colors.success.alpha};
      color: ${g.colors.success.text};
    `,
  warning: ({
    theme: g
  }) => `
      background-color: ${g.colors.warning.alpha};
      color: ${g.colors.warning.text};
    `,
  ratings: ({
    theme: g
  }) => `
      background-color: ${g.colors.ratings.alpha};
      color: ${b.ratings};
    `,
  notification: ({
    theme: g
  }) => `
      background-color: ${g.colors.danger.background};
      color: ${b.white};
    `
}, c = {
  medium: ({
    theme: g
  }) => `
      width: 32px;
      height: 32px;
      font-size: ${g.typography.bodyMBold.fontSize};
      font-family: ${g.typography.bodyMBold.fontFamily};
      font-weight: ${g.typography.bodyMBold.fontWeight};
    `,
  small: ({
    theme: g
  }) => `
      width: 20px;
      height: 20px;
      font-size: ${g.typography.bodySBold.fontSize};
      font-family: ${g.typography.bodySBold.fontFamily};
      font-weight: ${g.typography.bodySBold.fontWeight};
    `
}, I = ({
  variant: g
}) => l[g], G = ({
  size: g
}) => c[g], Z = /* @__PURE__ */ o("div", process.env.NODE_ENV === "production" ? {
  target: "e1unnqjx0"
} : {
  target: "e1unnqjx0",
  label: "StyledContainer"
})("display:inline-flex;border-radius:", ({
  theme: g
}) => g.radius.circle, ";justify-content:center;align-items:center;", I, " ", G, ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
export {
  Z as StyledContainer,
  G as sizeStyles
};
